import React from 'react';
import { Tooltip } from 'reactstrap';

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;    //basic email regex

class Email extends React.Component {
    constructor(props) {
        super(props)
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.validateOnMount = this.validateOnMount.bind(this);
        this.clearInput = this.clearInput.bind(this);
        const { value } = this.props;
        this.state = {
            tooltipOpen: false,
            invalidInput: false
        };
    }

    componentDidMount() {
        const { validateOnMount } = this.props;

        if (validateOnMount) {
            this.validateOnMount();
        }
    }
    toggleTooltip() {
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    onChange(event) {
        const { value } = event.target;       
        const isValid = this.isValid(value);

        if (this.props.onChange) {
            this.props.onChange(event, isValid);
        }

        if (this.state.invalidInput) {
            this.setState({
                invalidInput: !isValid
            });
        }

    }

    isValid(value) {
        if (value && !this.props.inValidMsg) {
            return value.trim() && emailPattern.test(value);
        } else {
            return this.props.required && !this.props.inValidMsg ? false : true;
        }

    }

    clearInput(event) {
        const e = { event, target: { value: "" , name: this.props.name ? this.props.name :""} };
        this.onChange(e);
    }

    validateOnBlur(event) {
        const value = event.target.value;
        const isValid = this.isValid(value);

        if (this.props.onChange) {
            this.props.onChange(event, isValid);
        }

        event.persist();
        this.setState({ invalidInput: !isValid });
    }

    validateOnMount() {
        const value = this.props.value;
        const isValid = this.isValid(value);
        this.setState({ invalidInput: !isValid });
    }

    render() {
        const {
            placeholder,
            value,
            required,
            name,
            id,
            autoFocus,
            disabled,
            inputErrorMsg,
            tooltipID,
            tooltipMsg,
            inValidMsg,
            showAsInvalid,
            showClearBtn
        } = this.props;

        const isValid = this.isValid(value);
        const containerClassName = (value ? ' input-not-empty' : '') + (this.state.invalidInput || showAsInvalid ? ' input-invalid' : '') + ((tooltipID && tooltipMsg) ? ' input-append' : '');

        return (
            <div className={'il-group' + containerClassName}>
                <input
                    type="email"
                    className="form-control"
                    value={value}
                    required={required}
                    name={name}
                    id={id}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder ? placeholder : 'Email'}
                    onChange={e => this.onChange(e)}
                    onBlur={this.validateOnBlur}          
                    title={placeholder ? "Please fill out the " + placeholder : "Please fill out the Email."}
                    aria-label={placeholder ? placeholder : 'Email'}
                />
                {tooltipID && tooltipMsg && (
                    <div className="input-icon-append ">
                        <span className="icon-info" id={tooltipID} />
                        <Tooltip
                            placement="top"
                            isOpen={this.state.tooltipOpen}
                            autohide={false}
                            target={tooltipID}
                            toggle={this.toggleTooltip}
                        >
                            {tooltipMsg}
                        </Tooltip>
                    </div>
                )}
                {showClearBtn && value &&
                    <div className="clear-btn-container">
                        <button className="clear-btn" type="button" aria-label="clear button" onClick={this.clearInput}><span className="icon-input-clear" /></button>
                    </div>
                }
                <div className="il-label" aria-hidden="true">{placeholder}</div>
                <div className="input-icon-append"><span className="icon-envelop" /></div>
                {inValidMsg ? <div className="input-error-msg">{inValidMsg}</div> :
                    !isValid && <div className="input-error-msg">{inputErrorMsg ? inputErrorMsg : (typeof value !== "undefined" && value) ? `Please enter a valid ${placeholder ? placeholder : 'email'}.` : ""}</div>}                
            </div>
        )
    }
}
export default Email;
